import { render, staticRenderFns } from "./certificare_tianjing.vue?vue&type=template&id=42c6d522&scoped=true&"
import script from "./certificare_tianjing.vue?vue&type=script&lang=js&"
export * from "./certificare_tianjing.vue?vue&type=script&lang=js&"
import style0 from "./certificare_tianjing.vue?vue&type=style&index=0&id=42c6d522&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6d522",
  null
  
)

export default component.exports